import { useTranslation } from "react-i18next";
import VideoPlayer from "../../components/video-demo/video-demo";
import { ContextPlansAndServicesProvider } from "../../contexts/contex-plans-and-services";

export default function VideoDemo({ infoUser }) {
  const [t] = useTranslation("global");

  if (!infoUser.isDemo) {
    return(
      <div>
        <h2>{t(`error404.message`)}</h2>
        <p>{t(`error404.description`)}</p>
      </div>
    )
  }

  return (
    <>
      <ContextPlansAndServicesProvider>
        <h1>{t('modals.videoDemo.title')}</h1>
        <h4 style={{fontWeight: 'normal'}}>{t('modals.videoDemo.description')}</h4>
        <VideoPlayer />
      </ContextPlansAndServicesProvider>
    </>
  )
}
